import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const comprobarFeriado = async ({ feriado, token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.ADP.FERIADOS.OBTENER}${feriado}`, extraHeaders: { token: token } });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default comprobarFeriado;